@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<div kb-layout="grid" class="row-container">
  <div kb-grid-item-columns="8" [appEditorId]="editorIds?.teasers">
    @for (teaser of attributes.teasers; track teaser; let index = $index) {
      <figure kb-overlay-figure
        class="teaser-visual-section"
        [class.active]="index === activeTeaserIndex"
        [heading]="teaser.headline"
        [abstract]="teaser.abstract"
        [link]="{ href: teaser.url }"
      >
        @for (tag of teaser.tags; track tag) {
          <kb-chip>{{ tag.label }}</kb-chip>
        }
        <kb-picture
          [picture]="imageToPicture(teaser.image.attributes, aspectRatio).sources"
          [appOgImage]="teaser.image.attributes"
          [alt]="teaser.image.attributes.alt"
          [rootColumns]="8"
          [appEditorId]="teaser.image.editorIds?.src"
        ></kb-picture>
      </figure>
    }
  </div>
  <div kb-grid-item-columns="4">
    <ul class="link-list">
      @for (teaser of attributes.teasers; track teaser; let index = $index) {
        <li [class.active]="index === activeTeaserIndex">
          <a [kbRouterOrExternalLink]="teaser.url" (click)="onTeaserListClick($event, index)">
            <time [attr.datetime]="teaser.date | date:'yyyy-MM-dd hh:mm:ssZZZZZ'">{{teaser.date | date:'longDate'}}</time>
            <h3 kb-heading class="link-heading">
              <kb-line-clamp lines="2">
                {{ teaser.headline }}
                <kb-icon [icon]="iconLink"></kb-icon>
              </kb-line-clamp>
            </h3>
          </a>
        </li>
      }
    </ul>

    <a kb-button [kbRouterOrExternalLink]="attributes.link.attributes.url" [attr.target]="attributes.link.attributes.target" [appEditorId]="editorIds?.link">
      @if (attributes.link.attributes.label === undefined) {
        <ng-container i18n="content teaser read more link@@2827984212740060090">Read more</ng-container>
      } @else {
        {{ attributes.link.attributes.label }}
      }
      <kb-icon [icon]="iconLink"></kb-icon>
    </a>
  </div>
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
